import { element, extend } from 'angular';

/**
 *
 * @param {string} html
 * @param {any} values
 * @returns {HTMLElement}
 */
const makeComponent = (html, values) => {
	const $injector = element(document).injector();
	const compile = $injector.get('$compile');
	const $scope = $injector.get('$rootScope');
	// const element1 = element(template);

	const scope = extend($scope.$new(true), {
		$ctrl: values,
	});
	const compiled = compile(html)(scope);
	return compiled[0];
};

/**
 * @param {string} componentName
 * @returns {import('@tiptap/core').NodeViewRenderer}
 */
// eslint-disable-next-line no-unused-vars
export function NgNodeViewRenderer(componentName) {
	return ({
		HTMLAttributes,
	}) => {
		let bindings = '';
		for (const [key] of Object.entries(HTMLAttributes)) {
			bindings += ` ${key}="$ctrl.${key}"`;
		}

		const html = `<${componentName}${bindings}></${componentName}>`;
		const dom = makeComponent(html, HTMLAttributes);

		return {
			dom,
		};
	};
}
